import React from 'react';
const ReportTemplateTitle = _ref => {
  let {
    customTitle
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, `Configure Full ${customTitle}`);
};
export default ReportTemplateTitle;